import React, { useState, useEffect } from "react";
import CustomFilters from "../../core/custom-filters";
import SiAutocomplete from "../../core/si-autocomplete";
import { HTTP_METHODS, plainApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { PAGE_LIMIT } from "../../utils";

const OEMFilters = ({ loadData, setMainFilters, filter }) => {
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [oemList, setOemList] = useState([]);
  const [oemOrgList, setOemOrgList] = useState([]);
  let oemTimeout = null;

  const applyFilters = (filters) => {
    const payload = {};
    if (Object.keys(filters).length) {
      for (let key in filters) {
        if (typeof filters[key] === "object" && filters[key]?.value) {
          payload[key] = filters[key].value;
        } else {
          payload[key] = filters[key];
        }
      }
      if (setMainFilters) {
        setMainFilters(payload);
      }
      loadData({
        ...payload,
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: filter?.page || 1,
      });
    } else {
      if (setMainFilters) {
        setMainFilters({});
      }
      loadData({
        ...payload,
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: filter?.page || 1,
      });
    }
  };
  const getOemOrg = (filters) => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.OEM_NAMES}`, null, {
      ...filters,
    })
      .then((response) => {
        if (response) {
          const result = response.map((ele) => ({
            label: ele.name,
            value: ele.id,
          }));
          setOemOrgList(result);
        }
      })
      .catch((err) => console.error(err));
  };
  const getOemList = (inputValue, type = "name") => {
    const params = inputValue ? { [type]: inputValue } : {};
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.LIST_ADMIN_OEMS}`,
      null,
      params
    )
      .then((response) => {
        if (Array.isArray(response) && response) {
          let oems = response.map((r) => {
            return {
              ...r,
              label: type === "name" ? `${r.code}-${r.name}` : r?.email,
              value: type === "name" ? r.code : r?.email,
            };
          });

          setOemList(oems);
        }
      })
      .catch((err) => console.error(err));
  };
  const handleRegexSearch = (newInputValue, type = "name") => {
    clearTimeout(oemTimeout);
    if (newInputValue) {
      oemTimeout = setTimeout(() => getOemList(newInputValue, type), 300);
    }
  };
  const filterTypes = [
    { label: "Filter by OEM Org", value: "oemOrg" },
    { label: "Filter by OEM Engineer", value: "code" },
    { label: "Filter by Email", value: "email" },
  ];
  const renderFilterInput = () => {
    switch (filterType) {
      case "code":
        return (
          <SiAutocomplete
            onChange={setFilterValue}
            options={oemList}
            placeholder="Search OEM Eng"
            onInputChange={(newInputValue) => handleRegexSearch(newInputValue)}
          />
        );
      case "oemOrg":
        return (
          <SiAutocomplete
            onChange={setFilterValue}
            options={oemOrgList}
            placeholder="Search OEM Org"
          />
        );
      case "email":
        return (
          <SiAutocomplete
            onChange={setFilterValue}
            options={oemList}
            placeholder="Search Email"
            onInputChange={(newInputValue) =>
              handleRegexSearch(newInputValue, "email")
            }
          />
        );
      default:
        return null;
    }
  };

  const handleFilterValueChange = (event) => {
    setFilterValue(event.target.value);
  };
  useEffect(() => {
    if (filterType === "name") {
      getOemList();
    }
    if (filterType === "oemOrg") {
      getOemOrg();
    }
  }, [filterType]);
  return (
    <div>
      <CustomFilters
        applyFilters={applyFilters}
        renderFilterInput={renderFilterInput}
        filterTypes={filterTypes}
        filterType={filterType}
        setFilterType={setFilterType}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default OEMFilters;
